<template>
	<az-container class="mb-1 ml-0 pa-7" fluid>
		<h3 class="color-titulo font-weight-bold color title">Justificativa</h3>
		<v-form ref="form" v-model="isFormJustificativaValid" lazy-validation>
			<v-row class="mt-md-2">
				<v-col cols="12">
					<v-textarea
						ref="justificativa"
						v-model.trim="justificativa"
						counter="500"
						maxlength="500"
						auto-grow
						outlined
						placeholder="Escreva o motivo da adesão"
						no-resize
						rows="5"
						:disabled="!podeHabilitarCampo()"
						@blur.stop="salvarDadosAderente"
					></v-textarea>
				</v-col>
			</v-row>
		</v-form>
	</az-container>
</template>
<script>
import { mapState } from 'vuex'
import { actionTypes } from '@/core/constants'
import { Alert } from '@/core/utils'
import mutationTypes from '@/core/constants/mutation-types'

export default {
	name: 'justificativa-adesao-view',
	data() {
		return {
			isFormJustificativaValid: false,
			alert: new Alert(this.$store),
			valorAnteriorJustificativa: '',
		}
	},
	computed: {
		...mapState({
			isFormAderenteValid: (state) => state.adesaoPublica.formIsValid,
			idSolicitacaoAdesao: (state) => state.adesaoPublica.idSolicitacaoAdesao,
			datasource: (state) => state.adesaoPublica.datasource,
			dadosFormAderente: (state) => state.adesaoPublica.estadoAnteriorForm,
			idAta: (state) => state.adesaoPublica.filtro.idAta,
		}),
		justificativa: {
			get() {
				return this.$store.state.adesaoPublica.justificativa
			},
			set(novoValor) {
				this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_JUSTIFICATIVA, novoValor)
			},
		},
	},
	beforeDestroy() {
		this.$store.commit(mutationTypes.ADESAO_PUBLICA.SET_JUSTIFICATIVA, '')
	},
	methods: {
		async salvarDadosAderente() {
			if (this.valorAnteriorJustificativa === this.justificativa) return

			await this.$store
				.dispatch(actionTypes.ADESAO_PUBLICA.SALVAR_INFORMACOES_SOLICITANTE, this.criarPayload())
				.then(() => this.alert.showSuccess(`Justificativa salva com sucesso!`))

			this.valorAnteriorJustificativa = this.justificativa
		},
		podeHabilitarCampo() {
			return this.isFormAderenteValid && this.quantidadeItensIsPreenchido()
		},
		quantidadeItensIsPreenchido() {
			return this.datasource.some((item) => item.quantidadeSolicitada)
		},
		criarPayload() {
			return {
				...this.dadosFormAderente,
				justificativa: this.justificativa,
				idAta: this.idAta.value,
			}
		},
	},
}
</script>

<style lang="stylus" scoped></style>
